import { useHistory } from 'react-router';
import { useMemoOne as useMemo } from 'use-memo-one';
import { useImmutableFunction } from '@niaratech/niara-react-components';
import { usePreviousIfEquals } from '@niaratech/niara-react-components/src';
import type { CriteriaForm } from '../app/base';
import { generateQueryString, parseQueryString } from '../util/hotels';
type SetCriteriaParam = (current: CriteriaForm) => CriteriaForm;
export type SetCriteria = {
  (c: CriteriaForm | SetCriteriaParam): void;
};
const useQueryStringHotelCriteria = (defaultCriteria?: Partial<CriteriaForm>): [CriteriaForm, SetCriteria, string] => {
  const history = useHistory();
  const urlSearch: string = [location.search?.substring(1), location.hash?.substring(1)].filter(Boolean).join('&');
  const _value = useMemo(() => {
    const value = parseQueryString(urlSearch);
    return defaultCriteria && value ? {
      ...defaultCriteria,
      ...value
    } : value || defaultCriteria as CriteriaForm;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
  // defaultCriteria - não atualizar para cada mudança na instância de defaultCriteria
  urlSearch]);
  const value = usePreviousIfEquals(_value);
  const setCriteria: SetCriteria = useImmutableFunction(c => {
    const newCriteria = typeof c === 'function' ? c(value) : c;
    const location = history.location;
    history.replace(location.pathname + '#' + generateQueryString(newCriteria));
  });
  const r: [CriteriaForm, SetCriteria, string] = useMemo(() => {
    return [value, setCriteria, urlSearch];
  }, [setCriteria, value, urlSearch]);
  return r;
};
export default useQueryStringHotelCriteria;